import { Platform, View } from 'react-native';

import gs from '@app/styles/globalStyles';
import ProfileIcon from '../../../../../assets/Icons/Profile';
import ROUTE from '@app/navigationApp/routes';
import NeedHelp from '@sharedComponents/NeedHelp/NeedHelp';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '@routes/types';
import ThemedTouchableOpacity from '@app/theme/Components/ThemedTouchableOpacity';
import { ThemedText, ThemedView } from '@app/theme'
import { ColorTokens, FontFamilyTokens, FontSizeTokens, TypographyTypeDLS } from '@voltmoney/schema';
import Typography from '@app/sharedComponents/typography/Typography';
import { isMobile } from '@voltmoney/micro-frontend';
import { useDarkMode } from '@app/utils';


type DashboardHeaderProps = {
  navigation : NativeStackNavigationProp<PrivateStackParamList>,
  name : string
  showMyAccountIcon: boolean
  callDataVisible: boolean
}

const _isMobile = isMobile()

const DashboardHeader = ({ navigation,callDataVisible, name, showMyAccountIcon = true }: DashboardHeaderProps) => {
  const welcome = callDataVisible ? name?.length <=10 ? 'Welcome, ' : 'Welcome!' : 'Welcome'
  const isDarkMode = useDarkMode();
  
  return (
    <ThemedView
      bg='bg-surface-primary'
      flexDirection='row'
      justifyContent='space-between'
      alignItems='center'
      paddingHorizontal='lg'
      height={60}
      style={[
      ]}>
      <View style={[gs.flexRow]}>
          <ThemedText color='text-primary' variant='h5s'>{welcome}</ThemedText>
        {callDataVisible && (name !== '' && name?.length <= 10)  && (
           <ThemedText color='text-action-primary' variant='h5s'>{name}</ThemedText>
        )}
      </View>
      <View style={[gs.flexRow]}>
        <NeedHelp callDataVisible={callDataVisible} />
        {showMyAccountIcon &&
          <ThemedTouchableOpacity
            eventName='PROFILE_ICON'
            hitSlop={{ left: 10, right: 10, top: 10, bottom: 10 }}
            ml='md'
            onPress={() => {
              navigation.navigate(ROUTE.USER_PROFILE);
            }}>
            <ProfileIcon />
          </ThemedTouchableOpacity>}
      </View>
    </ThemedView>
  );
};

export default DashboardHeader;
